import { useTranslation } from "react-i18next"

import { useLocale } from "@/shared/hooks/useLocale"
import type { LocaleCode } from "@/shared/i18n"
import { cn } from "@/shared/utils/cn"

export interface LangSwitchProps {
  className?: string
}

/**
 * 语言切换按钮：在本页支持的语言里循环切换。
 * 按钮上显示的是「点一下会切到的语言」，语言名用各自语言的自称。
 */
export function LangSwitch({ className }: LangSwitchProps) {
  const { t } = useTranslation()
  const { next, toggle } = useLocale()

  const label: Record<LocaleCode, string> = {
    zh_CN: t("common_lang_option_zh"),
    en_US: t("common_lang_option_en"),
    km_KH: t("common_lang_option_km"),
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className={cn(
        "rounded-full border border-line bg-white/90 px-3 py-1 text-xs text-ink-secondary",
        className,
      )}
    >
      {label[next]}
    </button>
  )
}
